import React from 'react';

import { Container, SectionHeader } from './PastAppointment.styled';
import { Heading } from 'components/v2/Typography/Heading';
import { Appointment } from 'kb-shared';
import { Badge } from 'screens/Messages/components/Badge/Badge';

import { getPastAppointments } from './PastAppointments.utils';
import { List } from '../List/List';

export const PastAppointments = ({ appointments }: { appointments?: Appointment[] }) => {
  const pastAppointments = getPastAppointments(appointments);

  if (pastAppointments.length === 0) return <></>;

  return (
    <Container>
      <SectionHeader>
        <Heading tag="div" styledAs="h3" noMargin>
          Past Appointments
        </Heading>
        <Badge label={String(pastAppointments.length)} type="default" size="md" />
      </SectionHeader>
      <List appointments={pastAppointments} />
    </Container>
  );
};
